import FetchApi from "../util/fetchApi";

export default class OperationalDashboard {
  baseURL = `/workspace`;

  constructor() {
    this.fetchApi = new FetchApi();
  }

  cancelRequest() {
    this.fetchApi.cancelRequest();
  }

  createQueryParamsString({ limit, page, orderBy, order }) {
    const queryParameters = [
      limit && `limit=${limit}`,
      ![undefined, null]?.includes(page) && `page=${page}`,
      orderBy && `orderBy=${orderBy}`,
      order && `order=${order}`,
    ]
      .filter(Boolean)
      .join("&");

    return queryParameters ? `?${queryParameters}` : "";
  }

  async getDataSourceMetrics(Workspace_id) {
    return (await this.fetchApi.get(this.baseURL + `/${Workspace_id}/operationalDashboard/dataSourceMetrics`)).data;
  }

  async getTopDataSourceList(Workspace_id, queryParams) {
    const queryString = this.createQueryParamsString(queryParams);

    return (
      await this.fetchApi.get(this.baseURL + `/${Workspace_id}/operationalDashboard/topDataSourceList${queryString}`)
    ).data;
  }

  async getTopEntityList(Workspace_id, queryParams) {
    const queryString = this.createQueryParamsString(queryParams);

    return (await this.fetchApi.get(this.baseURL + `/${Workspace_id}/operationalDashboard/topEntityList${queryString}`))
      .data;
  }
}
